export enum Sortings {
    DESCENDING = 'DESC',
    ASCENDING = 'ASC',
}
